import firebase from 'firebase';
import { useEffect, useState } from 'react';
import { Alert, Icon, Loader, Uploader } from 'rsuite';
import { FileType } from 'rsuite/lib/Uploader';

interface Props {
  imageUrl: string;
  path: string;
  onUpload: (url: string) => void;
}

export const FileUpload = (props: Props) => {
  const [value, setValue] = useState(props.imageUrl);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setValue(props.imageUrl);
  }, [props.imageUrl]);

  const onChange = (files: FileType[]) => {
    if (!files.length) return;
    const file = files[0];

    const ext = file.name!.split('.').pop();
    setLoading(true);
    firebase
      .storage()
      .ref()
      .child(`${props.path}/${new Date().getTime()}.${ext}`)
      .put(file.blobFile!)
      .then(async (snapshot) => {
        const url = await snapshot.ref.getDownloadURL();
        setValue(url);
        props.onUpload(url);
      })
      .catch((error) => {
        Alert.error(error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const uploadButton = (
    <div>
      {loading ? <Loader /> : <Icon icon="camera" size="5x" />}
      <div style={{ marginTop: 8 }}>アップロード</div>
    </div>
  );

  return (
    <Uploader autoUpload={false} fileList={[]} onChange={onChange}>
      {value ? <img src={value} alt="avatar" style={{ width: 200 }} /> : uploadButton}
    </Uploader>
  );
};
